<template>

    <div class="slider-wrapper">
        <span class="caption ft-xbld">{{ caption }}</span>
        <div class="slider-outer" ref="outer">
            <slider
                :handles="[startAt]"
                :step = "1"
                tooltips
                :range = "{ 
                    'min': rangeMin, 
                    'max': rangeMax 
                }" 
                @update="sliderUpdate"
            >
            </slider>
        </div>
    </div>

</template>

<script>

    export default {

        name: 'SliderWrapper',

        props: {
            caption: String,
            value: Number,
            startingNum: {
                type: Number,
                default: 5
            },
            rangeMin: {
                type: Number,
                default: 0
            },
            rangeMax: {
                type: Number,
                default: 10
            },
        },

        data() {
            return {
                startAt: 5
            }
        },

        created() {
            this.startAt = this.value ?? this.startingNum
        },

        methods: {

            sliderUpdate(event) {
                let cleanVal = parseInt(event.values[0])
                this.$refs.outer.getElementsByClassName('noUi-tooltip')[0].innerHTML = cleanVal
                this.$emit('updateSlider', cleanVal)
                this.$emit('input', cleanVal)
            }
        }
    }

</script>